export const m = { 
      //ytlogin.vue
      LoginError: 'login failed, please login again! ',
      //resetpassword2.vue
      ForgetPassword: 'Forgot Password?',
      PlsEnterToken: 'Please enter token',
      PlsEnterNewPassword: 'Please enter new password',
      PlsDoubleEnterNewPassword: 'Please enter new password again',
      OKBtn: 'OK',
      ModifySuccessful: 'Modify successful',
      PassModifyFailTokenError: 'Failed to change password due to invalid token',
      NetworkErrorPassModifyFail: 'Failed to change password due to network error',
      TwoTimePassNotEqual: 'Password confirmation doesn\'t match the password',
      PlsEnterAllInfo: 'Please enter all infomation',
      //resetpassword.vue
      PlsEnterOldPassword: 'Please enter old password',
      ResetPass: 'Reset password',
      ModifyPassFail: 'Failed to change password',
      //register.vue
      Register: 'Sign up',
      PlsEnterMobileEmailLoginName: 'Please enter your mobile, email or login name',
      PlsEnterPass: 'Please enter password',
      PlsEnterPassAgain: 'Please enter password again',
      RegisterOK: 'Sing up OK',
      TwicePassNotSame: 'Password confirmation doesn\'t match the password',
      PlsFillAllInfo: 'Please fill all infomation',
      //login.vue
      //OKBtn: '请输入手机号/邮箱/登录名',
      //OKBtn: '请输入密码',
      Login: 'Login',
      QuickRegister: 'Sign up',
      ForgetPass: 'Forgot Password?',
      NoPermission: 'Now no permission',
      //forgetpassword.vue
      PlsEnterCheckEmail: 'Please enter your verified email address',
      Send: 'Verify',
      EmailSendOK: 'Check your email for a link to reset your password, If it doesn\'t appear within a few minutes, check your spam folder',
      PlsEnterRightEmail: 'Please enter correct Email',
      //header.vue
      HomePage: 'Home Page',
      PlanMeeting: 'Schedule meeting',
      ControlMeeting: 'Control meeting',
      ScanCodeCheckin: 'Scan code checkin',
      MofifyPass: 'Change password',
      PersonProfile: 'Your profile',
      ChangeSkin: 'Change skin',
      Help: 'Help',
      Exit: 'Exit',
      //forthcomeing_meeting.vue
      ListOfUpcomingMeetings: 'Future Meeting List',
      AfterYear: ' Year Later',
      AfterMonth: ' Month Later',
      AfterDay: ' Day Later',
      AfterHour: ' Hour Later',
      AfterMinute: ' Minute Later',
      BeforeYear: ' Year ago',
      BeforeMonth: ' Month ago',
      BeforeDay: ' Day ago',
      BeforeHour: ' Hour ago',
      BeforeMinute: ' Minute ago',
      NowNoPlanMeetingList: 'No Meeting',
      //forthmeetingvmr.vue
      NowMeetingList: 'Ongoing Meeting List',
      //OKBtn: '目前没有安排会议列表',
      YouNoRight: 'You are no this right！',
      //historymeeting.vue
      HistoryMeetingList: 'History Meeting List',
      //OKBtn: '年后',
      //OKBtn: '目前没有安排会议列表',
      MeetingListGetError: 'Failed to get meeting list',
      //historyplaymeeting.vue
      HistoryMeetingLiveList: 'Recorded Meeting List',
      //meetingtemplate.vue
      MeetingTemplateList: 'Meeting Template List',
      PlsEnterMeetingTemplateName: 'Please enter meeting template name',
      DeleteConfirmation: 'Delete Confirmation',
      YouConfirmaDelete: 'Are you sure to delete?',
      Template: 'Template？',
      CancelBtn: 'Cancel',
      //OKBtn: '确定',   
      DeleteMeetingTemplateFail: 'Failed to delete meeting template',
      //OKBtn: '会议列表列表获取错误',
      //meetingtemplate_edit.vue
      MeetingTemplateDetail: 'Meeting Template Detail',
      TemplateName: 'Template Name',
      PlsEnterTemplateName: 'Please enter template name',
      MeetingName: 'Subject',
      PlsEnterMeeetingNO: 'Please enter meeeting number',
	  MeetingProfile: 'Profile',
      MeetingType: 'Type',
  
      InstantConference: 'Now',
      ReservedConference: 'Schedule',
      MeetingIntroduce: 'Description',
      PlsEnterMeetingIntroduce: 'Please enter description',
      Participants: 'Participants',
      ConferenceTerminal : 'Endpoints',
      ConferenceHost: 'Host',
      ConferenceRecord: 'Recording',
      ConferenceLive: 'Live',
      ModifyBtn: 'Modify',
      Meeting: 'Meeting',
      ModifyOK: 'Modified Successfully',
      MeetingNameNotNull: 'Please input meeting subject',
      OperateFail: 'Operate Failed',
      //pdf.vue
      PrePage: 'Prev Page',
      NextPage: 'Next Page',
      //list.vue
      SelectAll: 'Select All',
      SelectZero: ',Select:0 person',
      CompanyName: 'Company Name',
      Connector: 'Contact Person',
      //attendmeeting.vue
      ScheduleMeetingList: 'Scheduled Meeting List',
      //OKBtn: '安排会议',
      //Connector: '联系人',
      NewMeeting: 'New',
      PersonTemplate: 'Template',
      RecentHistoryConference: 'History',
      ConferenceNo: 'Number',
      PlsEnterConferenceNo: 'Meeting number',
      RandomMeetingNo: 'Random',
      //OKBtn: '会议名称',
      PlsEnterMeetingName: 'Meeting Subject',
      PlsEnterMeetingPassword: 'Meeting Password',
      MeetingPassword: 'Password',
      HidePassword: 'Hide',
     // OKBtn: '即时会议',
     // OKBtn: '预约会议',
      MeetingDate: 'Date time',
      SelectDate: 'Date',
      MeetingTime: 'Time',
      //OKBtn: '会议日期',
      MeetingDuration: 'Duration',
      //OKBtn: '会议介绍',
      PlsEnterMeetingIntroduce: 'Meeting Description',
     // OKBtn: '与会人员',
     // OKBtn: '与会终端',会议主持 会议录制 会议直播
      Appointment: 'Schedule',
      NewBtn: 'New',
      SuccessfulBtn: ' successful',
      MeetingNo: 'Number:',
      PlsAttendOnTime: 'Please attend on time！',
      MeetingNameNotNull: 'Please enter meeting subject',
      MeetingNameToLong: 'Meeting subject should be less than 15 characters',
      MeetingPasswordFormatError: 'Wrong meeting password',
      PlsFillDateTime: 'Please fill meeting date time ',
      AppointTimeShoudBigThanNow: 'Meeting start time should be at least 15 minutes later',
      //attendmeetinglist.vue
      MeetingNoticeColon: 'Meeting Notice:',
      MeetingNoColon: 'Number:',
      StartTimeColon: 'Start Time:',
      MeetingDurationColon: 'Duration:',
  
      Minute: 'Minute',
      NowNoPlanMeetingList: 'No available meetings',
      //broadcastpolling.vue
      BroadcastPoll: 'Broadcast Polling',      
      PlsEnterPollInterval: 'Please enter polling interval: ',
      Second: 'Second',
      TerminalListGetFail: 'Failed to retrieve endpoint list, please refresh the page ',
      NetworkException: 'Network Error',
      PlsSelectTerminal: 'Please select endpoint! ',
      BroadcastPollStartOK: 'Broadcast polling started successfully ',
      BroadcastPollStartFail: 'Failed to start broadcast polling',
      //calendar.vue
      MeetingDetails: 'Meeting Details ',
      TerminalName: 'Enpoint Name:',
      MeetingTime: 'Meeting Time:',
      //MeetingDurationColon: '会议时长:',
      MeetingCreatorColon: 'Meeting Creator :',
      OccupiedResources: 'occupied resources: ',
      OccupiedSummary: '(occupied / total) ',
      Sunday: 'Sunday',
      Monday: 'Monday',
      Tuesday: 'Tuesday',
      Wednesday: 'Wednesday',
      Thursday: 'Thursday',
      Friday: 'Friday',
      Saturday: 'Saturday',
      //calendarAdd.vue
      ConfirmTerminalSelection: 'Confirm terminal selection ',
      Year: 'Year',
      Month: 'Month',
      Day: 'Day',
      //OKBtn: '会议名称',终端名称: 会议时间: 会议时长: 会议创建人:
      //OKBtn: '已占用资源:',
      Whichine: 'Which Line:',
      HowMany: 'Which One:',
      //OKBtn: '分钟',
      TerminalAddOK: 'Enpoint added successfully ',
      TerminalAddFail: 'Failed to add endpoint ',
      //changemeeting.vue
      ModifyAppointmentMeeting: 'Edit Scheduled Meeting ',
      PlsEnterMeetingNo: 'Please enter meeting number ',
      //checkinrecord.vue
      CheckinRecord: 'Check in record',
      NoCheckinPerson: 'No one checked in',
      CheckinNumber: 'Number of check-in:',
      MeetingColon: 'Meeting:',
      UnitColon: 'Unit:',
      NameColon: 'Name:',
      MobileColon: 'Mobile:',
      EMailColon: 'Email:',
      CheckinListGetFail: 'Failed to retrieve check-in list, please refresh the page',
      //departmentListdetail.vue
      Address: 'Address Book',
      GetFail: 'Failed to retrieve',
      AddressGetFail: 'Failed to retrieve address book, please refresh the page',
      //doublestream.vue
      DualStreamFunction: 'Content Token',
      PlsenterTerminalName: 'Please enter the endpoint name ',
      DualStreamSenderOK: 'Content Token sender specified successfully ',
      DualStreamSenderFail: 'Failed to specify content token sender',
      ReuestFail: 'Request Fail',
      PlsSelectDualTerminal: 'Please select a content token endpoint',
      //help.vue
      Help: 'Help',
      //iframe.vue
      VideoOnDemand: 'Video On Demand',
      //index.vue
      ReturnToUnifiedLoginPlatform: 'Return to unified login platform',
      AppointManagement: 'Future Meeting',
      ConferenceOnDemand: 'Recorded',
      MeetingTemplate: 'Template',
      TerminalMangerment: 'Endpoint Management',
      GoingOn: 'Ongoing',
      HistoryMeeting: 'History Meeting',
      ComingSoon : 'Future',
      HistoryHeld : 'History',
      //meetdetail.vue
      VideoAccess: 'URI',
      ScanQRCodeJionMeeting: 'QR Code',
      TelephoneAccess: 'Telephone',
      LiveURL: 'Live URL',
      ClickToWatchLive: 'Click to watch live',
      Password: 'Password',
      MeetingSponsor: 'Owner',
      MeetingBrief: 'Description',
      MeetingParticipants: 'Participant',
      MeetingTerminal: 'Endpoint',
      MeetingHost: 'Host',
      CancelMeeting: 'Cancel',
      ModifyMeeting: 'Modify',
      ScanterminalQRCodeJionMeeting: 'QR Code',
      Return: 'Back',
      CloseConfirm: 'Terminate Meeting',
      ConfirmDeleteMeeting: 'Are you sure to delete this meeting? ',
      ClickDownloadTerminalSoftware: 'Download endpoint software',
      GetListFail: 'Failed to get list',
      GetBookMeetingListOK: 'Cancel appointment successfully!',
    
      //meetingact.vue
      Broadcast: 'Broadcast',
      InTheMeeting: 'In the meeting',
      PlsInputSearchTerminal : 'Search participant',
      AddUser: 'Add User',
      AddTerminal: 'Add',
      LayoutMode: 'Layout',
      OneKeyBroadcast: 'Broadcast',
      AudioControl: 'Audio',
      VideoControl: 'Video',
      //OKBtn: '双流功能',
      MeetingLock: 'Lock',
      SaveAsTemplate: 'Save As Template',
      SaveAs: 'Save As',
      CheckinRecord: 'Check In',
      MeetingEnd: 'Terminate',
      //OKBtn: '存为模板',
      LiveShare: 'Live Share',
      //RecordEnd: 'Record End',
     //OKBtn: '签到记录',会议结束 分屏模式
      SaveBtn: 'Save',
      ResumeBtn: 'Auto layout',
      SelectBroacastTerminal: 'Select participant',
      ConfirmCloseMeeting: 'Are you sure to terminate meeting?',
      ConfirMDeleteParticipants: 'Are you sure you want to delete the attendee? ',
      LiveConfirm: 'Live Confirm',
      OpenLiveAndShare: 'Open live and share？',
      Vertical: '',
      Horizontal: '',
      Upper: '',
      Middle: '',
      Bottom: '',
      HorizontalUP: '',
      NoRecordDevice: 'This feature cannot be used without a recording device',
      CanceledDualStreamSender: 'The specified content token sender has been cancelled',
      CanceledDualStreamSenderFail: 'Failed to UN specify content token sender',
      RollCallSuccessful : 'Roll Call Successful',
      RollCallFailed: 'Roll Call Failed',
      RollCallCancelledSuccessfully : 'Roll Call Cancelled Successfully',
      RollCallCancelledFail: 'Roll Call Cancelled Fail',
      SetUpTheMainVenueOK: 'Successfully set up lecture ',
      SetUpTheMainVenueFail: 'Failed to set main venue ',
  
      MainVenueCancelledSuccessfully: 'The lecture was cancelled successfully',
      MainVenueCancelledFail: 'Failed to cancel the main venue',
      BroadcastStatusCanNotSetHost: 'The main venue cannot be set because it is in broadcast status',
      PollStatusCanNotSetHost: 'Currently in round patrol status, unable to set main venue',
      CallrollCanNotSetHost: 'The main venue cannot be switched during roll call',
      NoHostNoCallroll: 'There is no main venue, no roll call is allowed',
      CallrollCanNotBroadcast: 'It is in roll call status and cannot be broadcast',
      PollStatusCanNotBroadcast: 'Current patrol status, unable to broadcast ',
      OneKeyBroadcastCancelOK: 'One click broadcast cancelled successfully',
      OneKeyBroadcastCancelFail: 'One click broadcast cancellation failed',
      CancelFail: 'Cancel Fail',
      BroadcastOK: 'Broadcast success ',
      BroadcastFail: 'Broadcast failure',
      ConnectOK: 'The connection was successful ',
      ConnectFail: 'connection failed ',
      DisconnectOK: 'Disconnected successfully ',
      DisconnectFail: 'Disconnection failed',
      LayoutOK: 'Split screen successfully ',
      LayoutFail: 'Split screen failed',
      LayoutResumeOK: 'Split screen recovery successful',
      LayoutResumeFail: 'Split screen recovery failed',
      SaveTemplateOK: 'Template saved successfully ',
      SaveTemplateFail: 'Save template fail',
      AudioOn: 'Audio is unmuted',
      AudioOff: 'Audio is muted',
      AllAudioOn: 'Everyone\'s audio is unmuted',
      AllAudioOff: 'Everyone\'s audio is muted',
      VideoOn: 'Video is unblocked',
      VideoOff: 'Video is blocked',
      AllVideoOn:  'Everyone\'s video is unblocked',
      AllVideoOff: 'Everyone\'s video is blocked',
      NoRecordDeviceNoThisFunction: 'No record device,no this function',
      MeetingStartRecord: 'Recording started',
      MeetingSuspendedRecord: 'Recording paused',
      MeetingResumeRecord: 'Recording resumed',
      MeetingEndRecord: 'Recording stopped',
      MeetingStartLock: 'Meeting is locked',
      MeetingStartUnlock: 'Meeting is unlocked',
      MeetingLockFail: 'Failed to lock meeting',
      MeetingUnlockFail: 'Failed to unlock meeting',
      DeleteTerminalOK: 'Endpoint is removed',
      CloseMeetingOK: 'Meeting is terminated',
      CloseMeetingFail: 'Fail to terminate meeting',
      NeetingNotice: 'Neeting Notice',    
      ReportToJiangsuMonday: 'Report To Jiangsu Monday',
      ClickConnectJionMeeting: 'Click this link to join meeting',
      Minute30: '30 Minute',
      //OKBtn: '扫二维码入会',
      NoticeDesc: 'This meeting is mainly about the sales in Jiangsu area. It summarizes the sales plan of this month, and analyzes the completion of sales tasks, turnover and customer demand',
      //nowmeeting.vue
      HistoryMeetingShort: 'History',
      SelectHistoryMeeting: 'Select history meeting',
      //OKBtn: '安排会议',
      //oneclickpolling.vue
      OneKeyPolling: 'Key Polling',
      Search: 'Search',
      PlsSelectTerminal: 'Please select endpoint',
      PlsSelectMainVenue: 'Please select lecturer',
      PlsSelectLayoutMode: 'Please select layout',
      OneKeyPollingStartOK: 'Polling started successfully',
      OneKeyPollingStartFail: 'Failed to start polling',
      PollingInterval: 'Polling Interval',
      PollingMode: 'Polling Mode',
      MainVenue: 'Lecturer',
      //peoplechoice.vue
      SelectionOfParticipants: 'Selection Of Participants',
      PlsEnterMeetingNameToSearch: 'Please enter meeting subject to search',
  
      Selectedcolon: 'Selected:',
      //OKBtn: '姓名:',
      //OKBtn: '单位:',
      //OKBtn: '手机:',
      //OKBtn: '邮箱:',
      AddressGetException: 'Failed to retrieve address book, please refresh the page',
      //personalmode.vue
      SelectMeetingTemplate: 'Select template',
      PersonTemplateGetFail: 'Failed to retrieve personal template list, redirect to new meeting 3 seconds later',
      HistoryMeetingListGetFail: 'Failed to retrieve history meeting list, redirect to new meeting 3 seconds later',
      //OKBtn: '会议名称不能为空',
      //OKBtn: '会议密码格式错误',   
      //roomchoice.vue
      ConferenceRoomSelection : 'Conference Room Selection',
      TerminalListGetFail: 'Failed to get endpoint list, please try again',
      //sxt.vue
      SacnQRCode: 'Sacn QR Code',
      PlsConfirmQRCode: 'Please make sure you scan the correct QR code ',
      CheckinOK: 'Sign in successfully!',
      AddTerminalkOK: 'Add endpoint successfully! ',
      AddterminalFail: 'Failed to invite endpoint! ',
      //terminaladd.vue
      AddTerminal: 'Add Endpoint',
      //terminalcontrol.vue
      TerminalMangermentList: 'Endpoint Mangement List',
      //terminalcontrolPctest.vue
      PlsenterTermnal: 'Please input endpoint ',
      //terminaltimeinfo.vue
      TerminaltimeDetail: 'Endpoint Time Detail',
      //userlist.vue
      Address: 'Address',
      PlsenterDepartmentConnector: 'Please enter department',
      Selectedcolon: ',Selected:',
      Number: 'Number',
      PlsSelectsharePerson: 'Please select share person！',
      MeetingShareOK: 'Meeting sharing success ',
      MeetingShareFail: 'Meeting sharing failed ',
      SearchResult: 'Search results ',
      PlsSelectPerson: 'Please select the person to add!',
      PersonAddOK: 'Personnel increase succeeded ',
      PersonAddFail: 'Personnel increase failed ',
      //usermessage.vue
      Edit: 'Edit',
      PlsClickSelectMobilePicture: 'Please select photo album',
      SelectCamoraOrSelectPicture: 'Or take a photo and then upload it!',
      SaveOK: 'Save successfully! ',
      PlsEnterRightMobileEMail: 'Please enter the correct mobile phone number and email address',
  
      SaveSpace: 'Save',
      //VVinfo.vue
      VideoConferenceRoomJoin: 'Video conference room join ',
      MobileAppJoin: 'Mobile app join ',
      JoinOK: 'Join successfully ',
      MeetingNoExist: 'Meeting does not exist ',
      MeetingNoOpen: 'The meeting has not started ',
      ParticipantsColon: 'Participant:',
      MeetinghostColon: 'Host:',
      MeetingPasswordColon: 'Password:',

      JoinFail: 'Failed to join the meeting ',
      GetDetailFail: 'Failed to get details ',
      //vvMeetingList.vue
      FormatOneClickEnterMeeting: 'Method 1: click on the following reserved information to join',
      Morning: 'Morning',
      NoArrangement: 'No Arrangement ',
  
      FormatSecondClickEnterMeetingNo: 'Method 2: input the conference number to join',
      ClickNextInfoJoin: 'Click on the reserved information below to join ',
      GetMeetingListFail: 'Failed to get meeting list ',
      //waitcheck.vue
      PlsImproveTheInformation: 'Please fill all information and wait for the administrator to review! ',
      UploadOK: 'Upload succeeded! ',
      UploadFailSendAgain: 'Failed to upload, please upload again!',    
      ExitSpace: 'Exit',
      SaveSpace: 'Save',
      CancelSpace: 'Cancel',

      ConfirmStopDoubleStream:'Cancel content token？',
      MeetingCreated:'Created',
      Successful: 'Sucessfully',
      ModifyFail: 'Fail to modify',

      JoiningMeetingURL: 'Meeting URL',
      IntranetJoinURL: 'Intranet URL',
      ExternalNetworkURL: 'Internet URL',
      NotAbilityCallOutsideNetworkPleaseContactPolyTechnicalTeamForSupport: 'Do not have the ability to call outside the network, please contact Poly technical team for support!',
      MeetingNumber: 'Meeting No.',
      TiangongMeetingNumber: 'Ensemble No.',
      TiangongJoiningConnection: 'Ensemble URL',	
  }


// WEBPACK FOOTER //
// ./src/lang/en-US.js